class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const facetButton = this.querySelector('.facets__button-show');
    if (facetButton) {
      facetButton.onclick = (event) => {
        event.currentTarget.querySelector('.label-hide').classList.toggle('hidden');
        event.currentTarget.querySelector('.label-show').classList.toggle('hidden');
        if (!event.currentTarget.classList.contains('facets__button-show_up')) {
          if (event.currentTarget.querySelector('.label-hide').classList.contains('hidden')) {
            let width = this.querySelector('.facets__container').offsetWidth + 32;
            this.querySelector('.facets__container').classList.add('hide');
            this.querySelector('.facets__container').style.marginLeft = `-${width + 64}px`;
            document.querySelector('.products-grid').style.marginLeft = `-${width}px`;
            document.querySelector('.facets__top').style.marginLeft = `-${width}px`;
          } else {
            this.querySelector('.facets__container').classList.remove('hide');
            this.querySelector('.facets__container').style.marginLeft = '0';
            document.querySelector('.products-grid').style.marginLeft = '0';
            document.querySelector('.facets__top').style.marginLeft = '0';
          }
          if (document.querySelector('.products-grid'))
            document.querySelector('.products-grid').classList.toggle('full-width');
          if (document.querySelector('.collection-results'))
            document.querySelector('.collection-results').classList.toggle('full-width');
        } else {
          if (event.currentTarget.querySelector('.label-hide').classList.contains('hidden')) {
            let height = this.querySelector('.facets__container').offsetHeight;
            this.querySelector('.facets__wrapper').style.marginTop = `-${height}px`;
          } else {
            this.querySelector('.facets__wrapper').style.marginTop = '0';
          }
        }
      };

      const collectionGridSection =
        document.querySelector('.collection-grid-section') || document.querySelector('.section-search');
      let prevWidth = 0;
      const sectionResizeObserver = new ResizeObserver((entries) => {
        const [entry] = entries;

        if (!facetButton.classList.contains('facets__button-show_up') && entry.contentRect.width !== prevWidth) {
          if (facetButton.querySelector('.label-hide').classList.contains('hidden')) {
            if (entry.contentRect.width > 749) {
              let width = this.querySelector('.facets__container').offsetWidth + 32;
              this.querySelector('.facets__container').classList.add('hide');
              this.querySelector('.facets__container').style.marginLeft = `-${width + 64}px`;
              document.querySelector('.products-grid').style.marginLeft = `-${width}px`;
              document.querySelector('.facets__top').style.marginLeft = `-${width}px`;
            } else {
              this.querySelector('.facets__container').classList.remove('hide');
              this.querySelector('.facets__container').style.marginLeft = '0';
              document.querySelector('.products-grid').style.marginLeft = '0';
              document.querySelector('.facets__top').style.marginLeft = '0';
            }
          }
        } else {
          if (
            facetButton.querySelector('.label-hide').classList.contains('hidden') &&
            entry.contentRect.width !== prevWidth
          ) {
            if (entry.contentRect.width > 749) {
              let height = this.querySelector('.facets__wrapper').offsetHeight;
              this.querySelector('.facets__wrapper').style.marginTop = `-${height}px`;
              prevWidth = entry.contentRect.width;
            } else {
              this.querySelector('.facets__wrapper').style.marginTop = '0';
            }
          }
        }
      });
      sectionResizeObserver.observe(collectionGridSection);
    }

    document.addEventListener('click', (e) => {
      const detailsList = document.querySelectorAll('.facets__wrapper--horizontal .facets__disclosure');
      const details = e.target.closest('.facets__disclosure[open]');

      if (!details && detailsList) {
        detailsList.forEach((item) => {
          item.removeAttribute('open');
        });
      }
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static getSectionFetchSearchParams(searchParams) {
    const container = document.getElementById('ProductGridContainer');
    if (container?.dataset.segmentPagination !== 'true') return searchParams;

    const params = new URLSearchParams(searchParams);
    ['page', 'segment_page', 'section_id', 'sections', 'segment_fetch'].forEach((key) => params.delete(key));
    return params.toString();
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    if (
      window.CollectionSegmentPagination?.handleFacetPageChange &&
      window.CollectionSegmentPagination.handleFacetPageChange(searchParams, updateURLHash)
    ) {
      return;
    }

    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const productGridContainer = document.getElementById('ProductGridContainer');
    const collectionEl = productGridContainer?.querySelector('.collection');
    if (collectionEl) collectionEl.classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    const fetchSearchParams = FacetFiltersForm.getSectionFetchSearchParams(searchParams);

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${fetchSearchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderSearchResultsCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderSearchResultsCount(html);
  }

  static renderProductGridContainer(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const grid = parsed.getElementById('ProductGridContainer');
    const container = document.getElementById('ProductGridContainer');
    if (grid && container) {
      container.innerHTML = grid.innerHTML;
      if (document.querySelector('.js-load-more') || document.querySelector('.js-infinite-scroll')) loadMore();
      colorSwatches();
      if (window.CollectionSegmentPagination) {
        window.CollectionSegmentPagination.clearCache();
        window.CollectionSegmentPagination.refresh();
      }
      document.dispatchEvent(new Event('pagination:updated'));
    }
  }

  static renderSearchResultsCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const source = parsed.getElementById('SearchResultsCount');
    const target = document.getElementById('SearchResultsCount');
    const searchForm = document.querySelector('.template-search__search .search');

    if (source && target) {
      target.replaceWith(document.importNode(source, true));
      return;
    }

    if (source && !target && searchForm) {
      searchForm.insertAdjacentElement('afterend', document.importNode(source, true));
      return;
    }

    if (!source && target) {
      target.remove();
    }
  }

  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const productCount = parsed.getElementById('ProductCount');
    const productCountDesktop = parsed.getElementById('ProductCountDesktop');
    const mobileProductCount = parsed.querySelector('.mobile-facets__count');
    const facetsTop = document.querySelector('.facets__top');
    const facetsSortWrapper = document.querySelector('.facets__sort-wrapper');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const mobileCount = document.querySelector('.mobile-facets__count');

    if (productCount || productCountDesktop) {
      if (container && productCount) {
        container.innerHTML = productCount.innerHTML;
        container.classList.remove('loading');
      }
      if (containerDesktop) {
        containerDesktop.innerHTML = productCountDesktop
          ? productCountDesktop.innerHTML
          : productCount?.innerHTML || '';
        containerDesktop.classList.remove('loading');
      }
      if (mobileCount) {
        mobileCount.innerHTML = mobileProductCount
          ? mobileProductCount.innerHTML
          : productCountDesktop?.innerHTML || productCount?.innerHTML || '';
      }
      if (facetsTop) facetsTop.classList.remove('hidden');
      if (facetsSortWrapper) facetsSortWrapper.classList.remove('hidden');
    } else {
      if (facetsTop) facetsTop.classList.add('hidden');
      if (facetsSortWrapper) facetsSortWrapper.classList.add('hidden');
    }
  }

  static getFilterKey(element) {
    return element?.dataset?.filterParam || element?.id || '';
  }

  static findLiveFilter(elementToRender) {
    const key = FacetFiltersForm.getFilterKey(elementToRender);
    if (!key) return null;

    const formId = elementToRender.closest('form')?.id;
    const formEl = formId ? document.getElementById(formId) : null;
    if (formEl) {
      const match = Array.from(formEl.querySelectorAll('.js-filter')).find(
        (element) => FacetFiltersForm.getFilterKey(element) === key,
      );
      if (match) return match;
    }

    return elementToRender.id ? document.getElementById(elementToRender.id) : null;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetSelectors =
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter';
    const fromFetch = Array.from(parsedHTML.querySelectorAll(facetSelectors));
    const activeFilter = event?.target?.closest('.js-filter');
    const activeKey = FacetFiltersForm.getFilterKey(activeFilter);
    const activeFormId = activeFilter?.closest('form')?.id;

    fromFetch.forEach((elementToRender) => {
      const key = FacetFiltersForm.getFilterKey(elementToRender);
      const formId = elementToRender.closest('form')?.id;
      const currentElement = FacetFiltersForm.findLiveFilter(elementToRender);
      if (!currentElement) return;

      const isActive = Boolean(activeKey && key === activeKey && formId === activeFormId);
      if (isActive) {
        FacetFiltersForm.renderCounts(elementToRender, currentElement);
        return;
      }

      currentElement.innerHTML = elementToRender.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!activeFacetsElement || !target) return;
      target.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const source = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!source || !target) return;
      target.innerHTML = source.innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    mobileForm?.closest('menu-drawer')?.bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static hasFilterParams(search = window.location.search) {
    const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
    for (const key of params.keys()) {
      if (key.startsWith('filter.')) return true;
    }
    return false;
  }

  static getUnfilteredSectionUrl() {
    const sectionId = document.getElementById('product-grid')?.dataset.id;
    if (!sectionId) return '';

    const url = new URL(window.location.pathname, window.location.origin);
    const current = new URLSearchParams(window.location.search);
    if (current.has('q')) url.searchParams.set('q', current.get('q'));
    if (current.has('options[prefix]')) {
      url.searchParams.set('options[prefix]', current.get('options[prefix]'));
    }
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  }

  static applyParamsToRoot(root, searchParams) {
    const params = new URLSearchParams(searchParams);

    root.querySelectorAll('input[type="checkbox"][name]').forEach((input) => {
      input.checked = params.getAll(input.name).includes(input.value);
    });

    root.querySelectorAll('input[name]').forEach((input) => {
      if (input.type === 'checkbox' || input.type === 'hidden' || input.type === 'range') return;
      if (!params.has(input.name)) return;
      input.value = params.get(input.name);
    });

    root.querySelectorAll('select[name]').forEach((select) => {
      if (params.has(select.name)) select.value = params.get(select.name);
    });

    root.querySelectorAll('price-range').forEach((priceRange) => {
      const numberInputs = priceRange.querySelectorAll('.field__input');
      const rangeInputs = priceRange.querySelectorAll('.field__range');
      const minValue = numberInputs[0]?.value || rangeInputs[0]?.min || 0;
      const maxValue = numberInputs[1]?.value || rangeInputs[1]?.max;
      if (rangeInputs[0]) rangeInputs[0].value = minValue;
      if (rangeInputs[1]) rangeInputs[1].value = maxValue || rangeInputs[1].max;
    });
  }

  static replaceFilterWrapper(selector, parsedHTML, searchParams) {
    const source = parsedHTML.querySelector(selector);
    const target = document.querySelector(selector);
    if (!source || !target) return;
    if (!source.querySelector('.js-filter')) return;

    FacetFiltersForm.applyParamsToRoot(source, searchParams);
    target.replaceWith(source);
  }

  static hydrateFullFilters() {
    if (!FacetFiltersForm.hasFilterParams()) return;

    const url = FacetFiltersForm.getUnfilteredSectionUrl();
    if (!url) return;

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const searchParams = window.location.search.slice(1);
        FacetFiltersForm.replaceFilterWrapper('#FacetsWrapperDesktop', parsedHTML, searchParams);
        FacetFiltersForm.replaceFilterWrapper('#FacetsWrapperMobile', parsedHTML, searchParams);
        document.querySelectorAll('price-range').forEach((element) => {
          if (typeof element.fillSlider === 'function') element.fillSlider();
        });
      })
      .catch(() => {});
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url, event);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.hydrateFullFilters();

class PriceRange extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this)),
    );
    this.setMinAndMaxValues();
    this.controlSlider();
    this.controlInput();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('.field__input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (!minInput || !maxInput) return;
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (!!value && value < min) input.value = min;
    if (!!value && value > max) input.value = max;
  }

  fillSlider() {
    const inputWrapper = this.querySelector('.facets__range');
    if (!inputWrapper) return;

    const inputsRange = inputWrapper.querySelectorAll('.field__range');
    const inputRangeFrom = inputsRange[0];
    const inputRangeTo = inputsRange[1];
    if (!inputRangeFrom || !inputRangeTo) return;

    const range = inputRangeTo.max - inputRangeTo.min;
    if (!range) return;
    const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
    const toCurrent = inputRangeTo.value - inputRangeTo.min;
    const minRange = (fromCurrent / range) * 100;
    const maxRange = (toCurrent / range) * 100;

    inputWrapper.setAttribute('style', `--range-min: ${minRange}%; --range-max: ${maxRange}%`);
  }

  controlSlider() {
    const inputWrapper = this.querySelector('.facets__range');
    const inputNumberWrapper = this.querySelector('.facets__price-wrapper');
    if (!inputWrapper || !inputNumberWrapper) return;

    const inputsRange = inputWrapper.querySelectorAll('.field__range');
    const inputRangeFrom = inputsRange[0];
    const inputRangeTo = inputsRange[1];
    const inputNumberFrom = inputNumberWrapper.querySelectorAll('.field__input')[0];
    const inputNumberTo = inputNumberWrapper.querySelectorAll('.field__input')[1];
    if (!inputRangeFrom || !inputRangeTo || !inputNumberFrom || !inputNumberTo) return;

    inputRangeFrom.oninput = () => {
      const from = parseInt(inputRangeFrom.value, 10);
      const to = parseInt(inputRangeTo.value, 10);
      if (from > to) {
        inputRangeFrom.value = to;
        inputNumberFrom.value = to;
      } else {
        inputNumberFrom.value = from;
      }

      this.fillSlider();
    };

    if (Number(inputRangeTo.value) <= 0) {
      inputRangeTo.style.zIndex = 2;
    } else {
      inputRangeTo.style.zIndex = 0;
    }

    inputRangeTo.oninput = () => {
      const from = parseInt(inputRangeFrom.value, 10);
      const to = parseInt(inputRangeTo.value, 10);
      if (from <= to) {
        inputRangeTo.value = to;
        inputNumberTo.value = to;
      } else {
        inputNumberTo.value = from;
        inputRangeTo.value = from;
      }

      if (Number(inputRangeTo.value) <= 0) {
        inputRangeTo.style.zIndex = 2;
      } else {
        inputRangeTo.style.zIndex = 0;
      }

      this.fillSlider();
    };
  }

  controlInput() {
    const inputWrapper = this.querySelector('.facets__range');
    const inputNumberWrapper = this.querySelector('.facets__price-wrapper');
    if (!inputWrapper || !inputNumberWrapper) return;

    const inputsNumber = inputNumberWrapper.querySelectorAll('.field__input');
    const inputNumberFrom = inputsNumber[0];
    const inputNumberTo = inputsNumber[1];
    const inputsRange = inputWrapper.querySelectorAll('.field__range');
    const inputRangeFrom = inputsRange[0];
    const inputRangeTo = inputsRange[1];
    if (!inputNumberFrom || !inputNumberTo || !inputRangeFrom || !inputRangeTo) return;

    const maxValue = inputRangeTo.max;
    const minValue = inputRangeTo.min || 0;

    [inputNumberFrom, inputNumberTo].forEach((input) => {
      input.addEventListener('keydown', function (e) {
        if (
          (e.key >= '0' && e.key <= '9') ||
          ['Backspace', 'Delete', 'Tab', 'Escape', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key) ||
          ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase()))
        ) {
          return;
        }
        e.preventDefault();
      });
      input.addEventListener('input', function () {
        const clean = this.value.replace(/[^0-9]/g, '');
        if (this.value !== clean) this.value = clean;
      });
    });

    inputNumberFrom.oninput = () => {
      const from = parseInt(inputNumberFrom.value, 10);
      const to = parseInt(inputNumberTo.value, 10);
      if (from > to) {
        inputRangeFrom.value = to;
        inputNumberFrom.value = to;
      } else {
        inputRangeFrom.value = from || minValue;
      }

      this.fillSlider();
    };

    inputNumberTo.oninput = () => {
      const from = parseInt(inputNumberFrom.value, 10) || minValue;
      const to = parseInt(inputNumberTo.value, 10) || maxValue;
      if (to > from) {
        if (to > maxValue) {
          inputRangeTo.value = maxValue;
          inputNumberTo.value = maxValue;
        } else {
          inputRangeTo.value = to;
        }
        this.fillSlider();
      }
    };

    inputNumberTo.onblur = () => {
      const from = parseInt(inputNumberFrom.value, 10) || minValue;
      const to = parseInt(inputNumberTo.value, 10) || maxValue;
      if (to <= from) {
        inputRangeTo.value = from;
        inputNumberTo.value = from;
        this.fillSlider();
      }
    };
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
